import {generatePseudo} from "@/utils/pseudoGenerator.js";

const randInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
const randFloat = (min, max, decimals = 2) => {
    const v = Math.random() * (max - min) + min;
    const p = Math.pow(10, decimals);
    return Math.round(v * p) / p;
};

// --- MOCK LEADERBOARD RUGBY ---
export const makeMockRugbyLeaderboardBackend = (
    homeTeam,
    awayTeam,
    count = 30,
    {
        meIndex = count - 1,
        startId = 100,
        realMatchResult = {winner: 'HOME', margin: 12}
    } = {}
) => {

    const seen = new Set();
    const uniquePseudo = () => {
        let p = generatePseudo();
        while (seen.has(p)) p = generatePseudo();
        seen.add(p);
        return p;
    };

    const BASE_STAKE = 5000; // Mise fictive de base pour calculer le maxPotential

    let list = Array.from({length: count}, (_, i) => {
        let predictionType; // 'HOME', 'AWAY', 'DRAW'
        let predMargin = null;
        let calculatedPoints = 0;

        // Cotes simulées
        const odds = randFloat(1.1, 3.5, 2);
        const maxPoints = Math.floor(BASE_STAKE * odds);

        // Coût par unité d'erreur (ex: on perd 10% du max par point d'écart)
        const costPerUnit = Math.floor(maxPoints * 0.05);

        // --- DISTRIBUTION DES PERFORMANCES ---

        // 1. LES EXPERTS (Top 20%) : Ils ont le bon vainqueur et une marge très proche
        if (i < count * 0.20) {
            predictionType = realMatchResult.winner; // Ils ont le bon vainqueur
            // Marge très proche du réel (ex: 12 +/- 3 points)
            predMargin = Math.max(1, realMatchResult.margin + randInt(-3, 3));

            // Calcul des points : Max - (Erreur * Coût)
            const error = Math.abs(predMargin - realMatchResult.margin);
            calculatedPoints = Math.max(0, maxPoints - (error * costPerUnit));
        }

        // 2. LES MOYENS (40% suivants) : Bon vainqueur mais marge éloignée
        else if (i < count * 0.60) {
            predictionType = realMatchResult.winner;
            // Marge éloignée (ex: 12 +/- 15 points)
            predMargin = Math.max(1, realMatchResult.margin + randInt(-15, 15));

            const error = Math.abs(predMargin - realMatchResult.margin);
            calculatedPoints = Math.max(0, maxPoints - (error * costPerUnit));
        }

        // 3. LES PERDANTS (Le reste) : Mauvais vainqueur ou Match Nul
        else {
            const isDrawBet = Math.random() > 0.8; // 20% de chance de parier Nul

            if (isDrawBet) {
                predictionType = 'DRAW';
                predMargin = null;
            } else {
                // Il parie sur l'équipe perdante
                predictionType = realMatchResult.winner === 'HOME' ? 'AWAY' : 'HOME';
                predMargin = randInt(1, 15);
            }
            calculatedPoints = 0; // Perdu
        }

        // --- CONSTRUCTION DE L'OBJET WINNING TEAM ---
        let winningTeamName = null;
        let winningTeamLogoUrl = null;

        if (predictionType === 'HOME') {
            const imgSrc = homeTeam.code
                ? `https://flagcdn.com/w160/${homeTeam.code.toLowerCase()}.png`
                : homeTeam.logoUrl;

            winningTeamName = homeTeam.name;
            winningTeamLogoUrl = imgSrc;
        } else if (predictionType === 'AWAY') {
            const imgSrc = awayTeam.code
                ? `https://flagcdn.com/w160/${awayTeam.code.toLowerCase()}.png`
                : awayTeam.logoUrl;
            winningTeamName = awayTeam.name;
            winningTeamLogoUrl = imgSrc;
        }
        // Si DRAW, reste null

        // Si c'est un DRAW, les champs spécifiques marge/coût doivent être null (selon ta spec)
        const isDraw = predictionType === 'DRAW';

        return {
            type: "RUGBY",
            participantId: startId + i,
            pseudo: uniquePseudo(),
            isMe: false, // Sera set après le tri
            rank: null,  // Sera set après le tri
            totalPoints: calculatedPoints,
            betAt: new Date().toISOString(),

            // Champs spécifiques Rugby
            winningTeamName: winningTeamName,     // Null si Draw
            winningTeamLogoUrl: winningTeamLogoUrl, // Null si Draw

            predictionMargin: isDraw ? null : predMargin, // Null si Draw
            pointsLostPerMarginUnit: isDraw ? null : costPerUnit, // Null si Draw

            odds: odds,
            maxPotentialPoints: maxPoints,
        };
    });

    // TRI PAR POINTS DÉCROISSANTS
    list.sort((a, b) => b.totalPoints - a.totalPoints);

    // GESTION DU "MOI"
    if (meIndex >= 0 && meIndex < list.length) {
        // Reset
        list.forEach(p => p.isMe = false);

        // Assigner Moi
        list[meIndex].isMe = true;
        list[meIndex].pseudo = "Moi (Demo Rugby)";
    }

    // ATTRIBUTION DES RANGS
    return list.map((p, idx) => ({
        ...p,
        rank: idx + 1
    }));
};